module.exports = __webpack_public_path__ + "static/6-70b9ded11a260f15c443b807dce7280b.jpg";